// components/Testimonials.jsx — Side-by-side testimonial cards

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { SectionWrapper, SectionTitle } from "./UI";

function QuoteIcon({ className = "" }) {
  return (
    <svg className={className} width="32" height="24" viewBox="0 0 32 24" fill="currentColor">
      <path d="M0 24V14.4C0 6.72 4.56 1.92 13.68 0l1.44 2.88C10.32 4.08 7.8 6.72 7.2 10.8H12V24H0zm18 0V14.4C18 6.72 22.56 1.92 31.68 0l1.44 2.88c-4.8 1.2-7.32 3.84-7.92 7.92H30V24H18z" />
    </svg>
  );
}

function TestimonialCard({ item, dark, isEs }) {
  const text = isEs ? (item.textEs || item.text) : item.text;
  const role = isEs ? (item.roleEs || item.role) : item.role;

  return (
    <div className={`rounded-2xl p-6 border h-full transition-all duration-300 hover:border-[#A3E635]/40 hover:-translate-y-1 ${dark ? "bg-white/[0.03] border-white/10" : "bg-[#E2E8F0]/30 border-[#E2E8F0]"}`}>
      <QuoteIcon className={`mb-4 ${dark ? "text-white/10" : "text-[#0F172A]/10"}`} />
      <p className={`text-sm leading-relaxed mb-6 italic ${dark ? "text-white/70" : "text-[#0F172A]/70"}`}>
        "{text}"
      </p>
      <div className="flex items-center gap-3">
        {item.avatar ? (
          <img src={item.avatar} alt={item.author} className="w-10 h-10 rounded-full object-cover border-2 border-[#A3E635]/30" />
        ) : (
          <div className="w-10 h-10 rounded-full bg-[#A3E635]/20 flex items-center justify-center text-[#A3E635] font-bold text-sm">
            {item.author?.charAt(0)}
          </div>
        )}
        <div>
          <p className="text-sm font-semibold">{item.author}</p>
          {role && <p className={`text-xs ${dark ? "text-white/40" : "text-[#0F172A]/40"}`}>{role}</p>}
        </div>
      </div>
      <div className="mt-4 flex gap-0.5">
        {[1,2,3,4,5].map((s) => <span key={s} className="text-[#A3E635] text-sm">★</span>)}
      </div>
    </div>
  );
}

export default function Testimonials({ content, t, dark, lang }) {
  const isEs = lang === "es";

  return (
    <SectionWrapper id="testimonials" dark={dark} bg="default">
      <SectionTitle title={t.testimonials.sectionTitle} dark={dark} />

      {/* Desktop: grid */}
      <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {content.map((item) => (
          <TestimonialCard key={item.id} item={item} dark={dark} isEs={isEs} />
        ))}
      </div>

      {/* Mobile: swiper */}
      <div className="md:hidden -mx-4 overflow-x-hidden">
        <style>{`
          .testimonials-swiper .swiper-pagination-bullet { background: #A3E635; opacity: 0.4; }
          .testimonials-swiper .swiper-pagination-bullet-active { background: #A3E635; opacity: 1; }
        `}</style>
        <Swiper
          className="testimonials-swiper pb-10"
          modules={[Pagination]}
          pagination={{ clickable: true }}
          spaceBetween={12}
          slidesPerView={1.2}
          slidesOffsetBefore={16}
          slidesOffsetAfter={16}
        >
          {content.map((item) => (
            <SwiperSlide key={item.id} className="!h-auto pb-2">
              <TestimonialCard item={item} dark={dark} isEs={isEs} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </SectionWrapper>
  );
}
